import CategoryBody from "components/AdministrationComponents/CategoryComponents/CategoryBody/CategoryBody";
import Header from "components/Common/Header/Header";
import React, { useEffect } from "react";

const Categories = () => {
  useEffect(() => {
    document.title = "Administration | Categories";
  }, []);
  return (
    <main id="app">
      <Header moduleName="administration" />
      <CategoryBody />
    </main>
  );
};

export default Categories;
